if (!customElements.get("m-product-tabs")) {
  class MProductTabs extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        tabContent: [".m-tab-content"],
      };

      this.domNodes = queryDomNodes(this.selectors, this);
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.initTabs();
      this.initMobileSelect();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const blockSelectedIsTab = event.target.classList.contains("m-tab-content");

          if (!blockSelectedIsTab || !this.tabs) return;

          const dataIndex = event.target && event.target.dataset.index;
          this.tabs.setActiveTab(dataIndex);
        });
      }
    }

    initTabs() {
      this.tabs = new MinimogTheme.Tabs(this, () => {
        /*
          This section no longer initializes product sliders.
          The callback is intentionally kept so the existing theme Tabs
          system can still activate/deactivate tab panels normally.
        */
      });
    }

    initMobileSelect() {
      this.select = this.querySelector("[data-tab-select]");

      if (!this.select || !this.tabs) return;

      this.select.addEventListener("change", () => {
        this.tabs.setActiveTab(parseInt(this.select.value));
      });
    }
  }

  customElements.define("m-product-tabs", MProductTabs);
}